'use client';

// import { KonkursFanzinButton } from './konkurs-fanzin-button';
// import { useKonkursFanzinApplyToForm } from '@/features/konkurs/hooks';

export const KonkursShareSection = () => {
  // const { onApplyClick } = useKonkursFanzinApplyToForm();

  return (
    <section className="w-full flex justify-center">
      <div
        className={[
          'relative flex w-full max-w-[356px] flex-col items-center justify-center overflow-hidden',
          'aspect-[356/474] bg-[url("/images/konkurs-fanzin/share/bg-share-mobile.png")] bg-cover bg-center',
          'lg:max-w-[1100px] lg:aspect-[1100/564] lg:bg-[url("/images/konkurs-fanzin/share/bg-share-desktop.png")]',
          'px-4 py-10 lg:px-8 lg:py-14',
        ].join(' ')}
      >
        <div className="relative z-10 flex flex-col items-center text-center">
          <h2 className="roboto-flex-compressed font-extra-black text-[50px] uppercase leading-[90%] tracking-[0%] text-[#FFFFFF] [leading-trim:cap] lg:text-[70px]">
            {/* <span className="block">Готов поделиться</span> */}
            <span className="block">Конкурс на участие</span>
            {/* <span className="block">своим летом?</span> */}
            <span className="block">в фанзине остановлен.</span>
          </h2>
          <p className="mt-4 text-center font-sans text-[20px] leading-[115%] tracking-[0%] [leading-trim:cap] lg:mt-6">
            {/* <span className="font-medium text-[#FFFFFF]">Подай заявку </span> */}
            <span className="font-medium text-[#FFFFFF]">
              Свяжемся с каждым автором, кто уже подал заявку. Следите за анонсами!{' '}
            </span>
            {/* <span className="font-extrabold text-[#FF3DAE]">до 31 мая</span> */}
          </p>
          {/* <div className="mt-6 flex justify-center lg:mt-8">
            <KonkursFanzinButton label="Подать заявку" fixedWidth onClick={onApplyClick} />
          </div> */}
        </div>
      </div>
    </section>
  );
};
